import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuthContext } from 'contexts/AuthContext';
import { NSButton } from 'bricks';
import DeleteModalConfirmationModal from 'views/Reports/components/DeleteReportConfirmationModal/DeleteModalConfirmationModal';
import { getReportsQueryKey } from 'views/Reports/hooks/useGetReports';
import { useDeleteReports } from '../../hooks/useDeleteReports';

export interface IActionRowProps {
    selectedRows: number[];
}

const ActionRow = ({ selectedRows }: IActionRowProps) => {
    const { selectedOrganizationId } = useAuthContext();
    const queryClient = useQueryClient();

    const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState<boolean>(false);
    const toggle = () => setIsDeleteModalOpen(!isDeleteModalOpen);

    const { mutate: deleteReports } = useDeleteReports();

    const handleDelete = () => {
        deleteReports(
            { orgId: selectedOrganizationId!, reportIds: selectedRows },
            {
                onSuccess: () => {
                    queryClient.invalidateQueries({ queryKey: [getReportsQueryKey, selectedOrganizationId!] });
                },
            },
        );
        toggle();
    };

    return (
        <>
            <div className="ActionRow p-2 rounded">
                <span className="text-white">
                    {selectedRows.length}
                    {' '}
                    selected
                </span>
                <NSButton className="ml-2" color="danger" outline text="Delete" data-testid="delete-toggle" callback={() => setIsDeleteModalOpen(true)} />
            </div>
            <DeleteModalConfirmationModal
                isOpen={isDeleteModalOpen}
                toggle={toggle}
                numberOfReportsToDelete={selectedRows.length}
                handleDelete={handleDelete}
            />
        </>
    );
};

export default ActionRow;
